import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/SystemApi/';
export const getList = (data)=>{
  return getInterface.post(`${prefixUrl}getMenuList`, data);
}
export const selectParentMenuList = (data)=>{
  return getInterface.post(`${prefixUrl}selectParentMenuList`, data);
}
export const addMenu = (data)=>{
  return getInterface.post(`${prefixUrl}addMenu`, data);
}
export const delMenu = (data)=>{
  return getInterface.post(`${prefixUrl}delMenu`, data);
}
export const selectMenuListByRoleId = (data)=>{
  return getInterface.post(`${prefixUrl}selectMenuListByRoleId`, data);
}
export const allMenu = (data)=>{
  return getInterface.post(`${prefixUrl}allMenu`, data);
}
// export const getNewMessageCount = (data)=>{
//   return getInterface.get(`${prefixUrl}getNewMessageCount`, data);
// }
export const getNewMessage = (data)=>{
  return getInterface.get(`${prefixUrl}getNewMessage`, data);
}